// extracted by mini-css-extract-plugin
export default {"OppositeLegLink":"OppositeLegLink_OppositeLegLink__NGU5Z","bpk-no-touch-support":"OppositeLegLink_bpk-no-touch-support__MmY2N"};